var $ = require('jquery');

var self = {};

self.initialise = function($fadeIn) {
  setTimeout(function() {
    $('.overlay-text').addClass('fade-in');
  }, 500);

  $('.scroll-content').click(function(e) {
    e.preventDefault();

    var id = $(this).attr('href');
    if (id.length > 0) {
      $('html,body').animate({ scrollTop: $(id).offset().top - 178 }, 500);
    }
  });

  //function autoResizeDiv() {
  //    var height = document.getElementById('bannerSection').style.height = window.innerHeight + 'px';
  //    var width = document.getElementById('bannerSection').style.width = window.innerwidth + 'px';
  //    var navHeight = $("header").style.height = window.innerHeight + 'px';

  //    $("#bannerSection").attr({
  //        width: $width,
  //        height: $height,
  //    });

  //    $("header").attr({
  //        height: $navHeight,
  //    });

  //}
  //window.onresize = autoResizeDiv;
  //autoResizeDiv();
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/bannerSlide.js